import type { RouteObject } from 'react-router';
import { CompanySettingsPage } from './pages/CompanySettingsPage';
import { CompanyTabRedirect } from './pages/CompanyTabRedirect';

/** Details is here; the Accounts tab's route belongs to the company-accounts feature. */
export const COMPANY_SETTINGS_ROUTES: RouteObject[] = [
  { path: 'company', element: <CompanyTabRedirect /> },
  { path: 'company/details', element: <CompanySettingsPage /> },
];
